/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".st0[_ngcontent-%COMP%]{fill:var(--bg-background-color)!important}.wave[_ngcontent-%COMP%]{position:absolute;bottom:-5px;transform:scale(1,1);width:100vw}"];
export { styles as styles };
